var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoadingElement',{attrs:{"object":_vm.ad,"loading-classes":"w-44 h-6 !flex","type":"span","text-height":false}},[(_vm.ad)?_c('span',{staticClass:"text-center rounded px-2.5 py-1 text-sm whitespace-nowrap",class:_vm.textClasses},[_vm._v("\n    "+_vm._s(_vm.dateText)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }